import {
  getRequestUuid,
  setAndGetUserUuid,
} from 'lib/FeaturesAndExperiments/setAndGetUserUUID'

export const getDefaultServiceProperties = () => ({
  anonymousId: getRequestUuid(),
  domain: window.location.hostname,
  funnelSection: 'landingPage',
  params: window.location.search,
  path: window.location.pathname,
  sessionId: setAndGetUserUuid(),
  triggeredAt: new Date().toISOString(),
})
